import { AvailableServicesType, EnvironmentConfigType } from './relay-types';

export const getAvailableServices = async (
    config: EnvironmentConfigType,
    authToken: string,
): Promise<AvailableServicesType> => {
    const response = await fetch(config.availableServicesUrl, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch available services: ${response.status} ${response.statusText}`);
    }

    return await response.json();
};
